import { LitElement, html, svg } from 'lit';

export class IconChevronRight16 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m5.5 13.75 5.5-5.5-5.5-5.5"></path></svg>`; }
}
if (!customElements.get('f-icon-chevron-right16', IconChevronRight16)) {
  customElements.define('f-icon-chevron-right16', IconChevronRight16);
}